import { hashedHistory } from '../index';

const push = hashedHistory.push;
const goBack = hashedHistory.goBack;
const replace = hashedHistory.replace;

export const navBack = () : void => goBack();
export const navPush = (pathname : string) : void => push(pathname);
export const navReplace = (pathname : string) : void => replace(pathname);
